<template>
  <section class="admin-content" id="contact-search">
    <!-- <Navbar/> -->
    <main class="admin-main">
      <section class="">
        <div class="">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="text-center">
                    <h1><strong>Add Enrollee Form </strong></h1>
                    <p>
                      (All fields marked with
                      <span class="text-danger">*</span> are compulsory)
                    </p>
                  </div>
                  <form @submit.prevent="submitForm">
                    <div class="form-row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="inputCity">Select Sector
                            <span class="text-danger">*</span></label>
                          <select class="form-control" required v-model="sector" disabled>
                            <option value="formal">Formal Sector</option>
                            <option value="informal">Informal Sector</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="inputCity">Select Plan Type
                            <span class="text-danger">*</span></label>
                          <select class="form-control" required v-model="register.plan_type" disabled>
                            <option value="Family">Family</option>
                            <option value="Individual">Individual</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-6" v-if="sector == 'informal'">
                        <div class="form-group">
                          <label for="inputCity">Select Informal Sector
                            <span class="text-danger">*</span></label>
                          <select class="form-control" required v-model="register.sector">
                            <option value="Basic Healthcare Provision Fund">
                              Basic Healthcare Provision Fund
                            </option>
                            <option value="State Equity Program">
                              State Equity Program (RivHealth)
                            </option>




                            <option value="Governor Sim Free Healthcare Workers Scheme">
                              Governor Sim Free Healthcare Workers Scheme
                            </option>


                            <option value="CEmOC BHCPF">
                              CEmOC BHCPF
                            </option>


                            <option value="SCIMA Sickle Cell Program">
                              SCIMA Sickle Cell Program
                            </option>

                          </select>
                        </div>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Special Needs:
                          {{ register.category_of_vulnerable_group }}
                        </label>
                        <select class="form-control" :required="sub_vulnerables.length === 0"
                          v-model="register.category_of_vulnerable_group" @change="updateSub">
                          <option :value="vul" v-for="vul in vulnerables" :key="vul">
                            {{ vul }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Sub Category</label>
                        <select class="form-control" v-model="register.category_of_vulnerable_group">
                          <option :value="vul" v-for="vul in sub_vulnerables" :key="vul">
                            {{ vul }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Select Organization </label>
                        <v-select v-model="register.place_of_work" :options="mdas" label="name"
                          :reduce="name => name.name"></v-select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4">
                          NIN Number
                          <span v-if="register.sector == 'Basic Healthcare Provision Fund'" class="text-danger">*</span>
                        </label>
                        <input type="text" inputmode="numeric" pattern="\d{11}" maxlength="11" class="form-control"
                          v-model="register.nimc_number"
                          @input="register.nimc_number = register.nimc_number.replace(/\D/g, '').slice(0, 11)"
                          :required="register.sector == 'Basic Healthcare Provision Fund'" placeholder="NIN Number" />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputPassword4">Surname <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.lastname"
                          placeholder="Last Name" pattern="[A-Za-z-]+" />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputEmail4">First Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.firstname"
                          placeholder="First Name" pattern="[A-Za-z-]+" />
                      </div>

                      <div class="form-group col-md-4">
                        <label for="inputPassword4">Middle Name</label>
                        <input type="text" class="form-control" v-model="register.middlename" placeholder="Middle Name"
                          pattern="[A-Za-z\s-]+" />
                      </div>
                      <!-- Expected Date of Delivery only shown when Pregnant Women Vulnerable group is selected-->
                      <div class="form-group col-md-4"
                        v-if="register.category_of_vulnerable_group === 'Pregnant Women'">
                        <label for="inputPassword4">Expected Date of Delivery (EDD)</label>
                        <input type="date" class="form-control" v-model="register.expected_date_delivery" />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <p>
                          <label for="inputPassword4">Date of Birth<span class="text-danger">*</span>
                          </label>
                          <small v-if="isChildUnder5Category" class="text-info d-block">
                            Must be under 5 years old
                          </small>
                          <small v-else-if="isAgedCategory" class="text-info d-block">
                            Must be 60 years or older
                          </small>
                          <small v-else-if="isPregnantCategory" class="text-info d-block">
                            Must be at least 13 years old
                          </small>
                        </p>

                        <input type="date" required class="form-control" v-model="register.dob" :max="dobMax"
                          :min="dobMin" />
                      </div>
                      <!-- <div class="form-group col-md-6">
                        <p>
                          <label for="inputPassword4">Expiry Date<span class="text-danger">*</span>
                          </label>
                        </p>
                        <input type="date" required class="form-control" v-model="register.expiry_date" />
                      </div> -->
                      <div class="form-group col-md-6">
                        <label for="inputEmail4">Email </label>
                        <input type="email" class="form-control" v-model="register.email" placeholder="Email" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Phone Number
                          <span class="text-danger">*</span></label>
                        <input v-phone type="tel" pattern="\d*" class="form-control" required
                          v-model="register.phone_number" placeholder="Phone Number" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputCity">Gender <span class="text-danger">*</span></label>
                        <small v-if="isPregnantCategory" class="text-info d-block">
                          Locked to Female for Pregnant Women
                        </small>
                        <select class="form-control" required v-model="register.gender" :disabled="genderDisabled">
                          <option value="Male" :disabled="isPregnantCategory">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Marital Status
                          <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.marital_status">
                          <option value="Married">Married</option>
                          <option value="Widow">Widow</option>
                          <option value="Single">Single</option>
                          <option value="Separated">Separated</option>
                          <option value="Divorced">Divorced</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">LGA <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.localgovt" @change="fetchWards($event)">
                          <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                            {{ lga.local_name }}
                          </option>
                        </select>
                      </div>


                      <div class="form-group col-md-6">
                        <label>Principal Facility for Accessing Health Care <span class="text-danger">*</span></label>
                        <v-select v-model="register.provider_id" :options="providers" label="agency_name"
                          :reduce="agency_name => agency_name.id" :value="register.provider_id"
                          :required="!register.provider_id"></v-select>
                        <small v-if="register.localgovt && !(providers || []).length" class="text-muted d-block mt-1">No facility listed for this LGA or ward. Click <b>All</b> to choose from every facility in the state.</small>
                        <button class="btn btn-info btn-sm my-2" @click="getProviders" type="button">All</button>

                        <!-- <select class="form-control" required v-model="register.provider_id">
                          <option v-for="facility in providers" v-bind:key="facility.id" :value="facility.id">
                            {{ facility.agency_name }}
                          </option>
                        </select> -->
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">Provider Ward</label>
                        <input type="text" class="form-control" :value="selectedProviderWard" disabled
                          placeholder="Auto-filled from selected facility" />
                      </div>

                      <div class="form-group col-md-6">
                        <label>Ward </label>

                        <select class="form-control" required v-model="register.ward">
                          <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">
                            {{ ward.ward_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Community <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.community">
                          <option value="">-- Select Community --</option>
                          <option v-for="c in communities" :key="c.id" :value="c.id">
                            {{ c.name }}
                          </option>
                        </select>

                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">Blood Group </label>
                        <select class="form-control" v-model="register.blood">
                          <option value="">NA</option>
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                        </select>
                      </div>


                      <div class="form-group col-md-6">
                        <label>Occupation <span class="text-danger">*</span></label>
                        <v-select v-model="register.occupation" :options="occupations" :value="register.occupation"
                          :required="!register.occupation"></v-select>
                      </div>

                      <div class="form-group col-md-6" v-if="register.occupation == 'Others'">

                        <label for="inputAddress">Specify Occupation</label>
                        <input type="text" class="form-control" required v-model="register.other_occupation"
                          placeholder="Occupation" />
                      </div>

                      <div class="form-group col-md-6">
                        <label>Highest Qualification <span class="text-danger">*</span></label>
                        <v-select v-model="register.education" :options="qualifications" :value="register.education"
                          :required="!register.education"></v-select>
                      </div>

                      <div class="form-group col-md-6" v-if="register.education == 'Others'">

                        <label for="inputAddress">Specify Qualification</label>
                        <input type="text" class="form-control" required v-model="register.other_education"
                          placeholder="Qualification" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputAddress">Home Address <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.address"
                          placeholder="1234 Main St" />
                      </div>

                    </div>

                    <div class="form-group col-md-12">
                      <button class="btn btn-outline-info" type="button" @click="takePicAndroid">
                        Capture Photo <i class="fe fe-camera"></i>
                      </button>

                      <div class="fileinput fileinput-new" data-provides="fileinput">
                        <span class="btn btn-file">
                          <span class="fileinput-new">Upload Photo <i class="fe fe-upload"></i></span>
                          <span class="fileinput-exists">Change</span>
                          <input type="file" name="..." multiple v-on:change="attachPic" />
                          <pre id="output"></pre>
                        </span>
                        <span class="fileinput-filename"></span>
                        <a href="#" class="close fileinput-exists" data-dismiss="fileinput"
                          style="float: none">&times;</a>
                      </div>
                    </div>

                    <div class="form-group col-md-6">
                      <img v-if="register.user_image" :src="`${register.user_image}`" class="rounded" alt="User Photo"
                        onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'" />
                      <div class="mt-2" v-if="register.user_image && photoOriginal">
                        <button class="btn btn-outline-secondary btn-sm" type="button" @click="cropPhoto(photoOriginal)">
                          <i class="fe fe-crop mr-1"></i> Adjust
                        </button>
                      </div>

                    </div>

                    <div>
                      <p class="mb-2">
                        <strong>
                          Declaration & warranty on behalf of all persons
                          proposed to be insured</strong>
                      </p>

                      <div class="form-group">
                        <div class="form-check">
                          <input required class="form-check-input" type="checkbox" id="checkbox1" />
                          <label class="form-check-label" for="checkbox1">
                            I/We hereby declare, on my behalf and on behalf of
                            all persons proposed to be insured that the above
                            statements, answers and/or particulars given by me
                            are true and complete in all respects to the best of
                            my knowledge and that I/We am/ are authorized to
                            propose on behalf of these other persons.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input required class="form-check-input" type="checkbox" id="checkbox1" />
                          <label class="form-check-label" for="checkbox1">
                            I understand that the information provided by me
                            will form the basis of insurance policy, is subject
                            to the Board approved underwriting policy of RIVCHPP
                            and that the policy will come into force only after
                            full receipt of the premium chargeable.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input required class="form-check-input" type="checkbox" id="checkbox1" />
                          <label class="form-check-label" for="checkbox1">
                            I/ We further declare that I/We will notify in
                            writing any change occurring in the occupation or
                            general health of the life to be insured/ proposer
                            after the proposal has been submitted but before
                            communication of the risk acceptance by RIVCHPP.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input required class="form-check-input" type="checkbox" id="checkbox1" />
                          <label class="form-check-label" for="checkbox1">
                            I/We declare and consent to RIVCHPP seeking medical
                            information from any hospital who at any time has
                            attended on the life to be insured/ proposer or from
                            any past or present employer concerning anything
                            which affects the physical and mental health of the
                            life to be assured/proposer and seeking information
                            from any insurance company to which an application
                            for insurance on the life to be assured/ proposer
                            has been made for the purpose of underwriting the
                            proposal and/or claim settlement.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input required class="form-check-input" type="checkbox" id="checkbox1" />
                          <label class="form-check-label" for="checkbox1">
                            I/ We authorize RIVCHPP to share information
                            pertaining to my proposal including the medical
                            records for the sole purpose of proposal
                            underwriting and/or claims settlement and with any
                            Governmental and/or Regulatory Authority.
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <button class="btn btn-success btn-block btn-lg">
                        Submit <i class="fe fe-send"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
            </div>
          </div>
        </div>
      </section>
      <PhotoCropper ref="photoCropper" />
    </main>
  </section>
</template>

<script>
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
  import PhotoCropper from "@/components/PhotoCropper.vue";
  import occupations from "@/jsons/occupations.json";
  import qualifications from "@/jsons/qualifications.json";
  import moment from "moment";
  moment().format();



  export default {
    components: { PhotoCropper,
      Loading,
    },
    data() {
      return {
        photoOriginal: "",
        isLoading: false,
        fullPage: true,
        genderDisabled: false,
        vulnerables: [
          "Pregnant Women",
          "Children under 5",
          "Elderly above 60",
          "Persons with Disability",
          "Chronically ill",
          "Retirees",
          "Widows",
          "Poor, below $1 a day",
          "Adult",
        ],
        sub_vulnerables: [],
        states: "",
        show: false,
        max_age: moment().format("YYYY-MM-DD"),
        min_age: moment().subtract(125, "years").format("YYYY-MM-DD"),
        clients: "",
        providers: "",
        sector: "informal",
        wards: "",
        communities: [],
        tpas: "",
        providers_wards: "",
        state: "",
        OfficerDetails: "",
        current_page: "",
        selected_provider: "",
        selected_provider_dependents: "",
        occupations: occupations,
        qualifications: qualifications,
        mdas: "",
        lga_states: "",
        response: "",
        register: {
          user_image: "",
          firstname: "",
          lastname: "",
          middlename: "",
          nimc_number: "",
          email: "",
          phone_number: "",
          plan_type: "Individual",
          type: "client",
          agency_id: "",
          state: "",
          localgovt: "",
          ward: "",
          address: "",
          blood: "",
          weight: "",
          gender: "",
          genotype: "",
          dob: "",
          expiry_date: "",
          salary_number: "",
          provider_id: "",
          point_of_care: "",
          sector: "",
          expected_date_delivery: "",
          finger_print: "",
          place_of_work: "",
          org_id: "",
          grade_level: "",
          date_of_entry: "",
          marital_status: "",
          category_of_vulnerable_group: "",
        },
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },

    computed: {
      selectedProviderWard() {
        if (!this.register.provider_id || !this.providers) return "";
        const provider = this.providers.find(p => p.id === this.register.provider_id);
        return provider && provider.ward ? provider.ward.ward_name : "";
      },
      categoryLower() {
        return (this.register.category_of_vulnerable_group || "").toLowerCase();
      },
      isChildUnder5Category() {
        return this.categoryLower.includes("under 5");
      },
      isAgedCategory() {
        return this.categoryLower.includes("elderly");
      },
      isPregnantCategory() {
        return this.categoryLower.includes("pregnant");
      },
      dobMin() {
        if (this.isChildUnder5Category) {
          return moment().subtract(5, "years").format("YYYY-MM-DD");
        }
        if (this.isAgedCategory) {
          return moment().subtract(125, "years").format("YYYY-MM-DD");
        }
        return this.min_age;
      },
      dobMax() {
        if (this.isChildUnder5Category) {
          return moment().format("YYYY-MM-DD");
        }
        if (this.isAgedCategory) {
          return moment().subtract(60, "years").format("YYYY-MM-DD");
        }
        if (this.isPregnantCategory) {
          return moment().subtract(13, "years").format("YYYY-MM-DD");
        }
        return this.max_age;
      },
    },

    watch: {
      "register.category_of_vulnerable_group"(newVal) {
        if ((newVal || "").toLowerCase().includes("pregnant")) {
          this.register.gender = "Female";
        }
      },
      "register.provider_id"(providerId) {
        this.onFacilitySelect(providerId);
      },
    },

    methods: {

      submitForm() {
        if (this.user.type == "employee") {
          if (this.register.provider_id != "") {
            this.registerUserEmployee();
          } else {
            this.$toasted.error(`Facility or Image cannot be empty`, {
              position: "top-center",
              duration: 3000,
            });
          }
        }
      },
      fetchWards() {
        this.register.ward = "";
        this.register.provider_id = "";
        this.communities = [];
        this.register.community = "";
        this.axios
          .get(`/api/v1/auth/getwards/${event.target.value}`)
          .then((response) => {
            this.wards = response.data.data;
            this.getProvidersByLGAs();
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      onFacilitySelect(providerId) {
        if (!providerId || !this.providers) return;
        const provider = this.providers.find(p => p.id === providerId);
        if (!provider) return;

        const lgId = provider.localgovt
          ? (typeof provider.localgovt === "object" ? provider.localgovt.id : Number(provider.localgovt))
          : null;
        if (lgId) this.register.localgovt = lgId;

        const wardId = provider.ward
          ? (typeof provider.ward === "object" ? provider.ward.id : Number(provider.ward))
          : null;
        if (wardId) this.register.ward = wardId;

        const communityId = provider.community
          ? (typeof provider.community === "object" ? provider.community.id : Number(provider.community))
          : null;

        if (communityId) {
          this.communities = provider.community && typeof provider.community === "object"
            ? [provider.community]
            : this.communities;
          this.register.community = communityId;
        } else {
          this.communities = [];
          this.register.community = "";
          if (wardId) this.fetchCommunities(wardId);
        }
      },

      fetchCommunities(wardId) {
        const id = wardId || null;
        if (!id) return;
        this.communities = [];
        this.register.community = "";
        this.axios
          .get(`/api/v1/auth/communities`, {
            params: { ward_id: id }
          })
          .then((response) => {
            this.communities = response.data || [];
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministries/407465`, {
            params: {
              type: 'private',
            },
          })
          .then((response) => {
            this.mdas = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },


      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/2679`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      // Opens the cropper; keeps the uncropped photo so it can be adjusted again.
      async cropPhoto(src) {
        const cropped = await this.$refs.photoCropper.open(src);
        if (!cropped) return false;
        this.photoOriginal = src;
        this.register.user_image = cropped;
        return true;
      },
      async takePicAndroid() {
        try {
          const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.Base64,
            source: CameraSource.Camera,
          });

          if (!(await this.cropPhoto("data:image/jpeg;base64," + image.base64String))) return;
          this.$toasted.info("Image taken Successfully!", {
            position: "top-center",
            duration: 8000,
          });
        } catch (err) {
          if (err && err.message !== "User cancelled photos app") {
            this.$toasted.error("Could not access camera.", {
              position: "top-center",
              duration: 3000,
            });
          }
        }
      },
      attachPic(event) {
        let imageFile = event.target.files[0];

        if (imageFile) {
          const reader = new FileReader();

          reader.onload = (e) => {
            // The result contains the Base64 string
            let base64Data = e.target.result;
            console.log(base64Data); // You can use the Base64 string here
            this.cropPhoto(base64Data);
          };

          reader.readAsDataURL(imageFile);
        }
      },

      registerUserEmployee() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/registerProvider", {
            agency_id: 407465,
            user_image: this.register.user_image,
            nimc_number: this.register.nimc_number,
            firstname: this.register.firstname.toUpperCase(),
            lastname: this.register.lastname.toUpperCase(),
            middlename: this.register.middlename.toUpperCase(),
            email: this.register.email,
            phone_number: this.register.phone_number,
            plan_type: this.register.plan_type,
            type: this.register.type,
            sectorType: this.sector,
            provider_id: this.register.provider_id,
            state: "2679",
            role: 0,
            password: "euhler",
            org_id: this.register.org_id,
            localgovt: this.register.localgovt,
            ward: this.register.ward,
            blood: this.register.blood,
            dob: this.register.dob,
            expiry_date: this.register.expiry_date,
            address1: this.register.address,
            genotype: this.register.genotype,
            place_of_work: this.register.place_of_work,
            weight: this.register.weight,
            gender: this.register.gender,
            sector: this.register.sector,
            expected_date_delivery: this.register.expected_date_delivery,
            point_of_care: this.register.provider_id,
            finger_print: this.register.finger_print,
            salary_number: this.register.salary_number,
            grade_level: this.register.grade_level,
            occupation: this.register.other_occupation == null ? this.register.occupation : this.register.other_occupation,
            education: this.register.other_education == null ? this.register.education : this.register.other_education,
            community: this.register.community,
            date_of_entry: this.register.date_of_entry,
            marital_status: this.register.marital_status,
            category_of_vulnerable_group:
              this.register.category_of_vulnerable_group,
            enrolled_by: this.user.id,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            // this.clearForm();
            this.$toasted.info("Client added Successfully", {
              position: "top-center",
              duration: 7000,
            });
            let user_id = response.data.data.id;
            this.$router.push(`/client/${user_id}`);
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.response = error.response.data.errors;
            this.$toasted.error(`${JSON.stringify(this.response)}`, {
              position: "top-center",
              duration: 3000,
            });
          });
      },
      clearForm() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

        this.register.user_image = ""
        this.register.firstname = ""
        this.register.lastname = ""
        this.register.middlename = ""
        this.register.nimc_number = ""
        this.register.email = ""
        this.register.phone_number = ""
        this.register.plan_type = "Individual"
        this.register.type = "client"
        this.register.state = ""
        this.register.localgovt = ""
        this.register.ward = ""
        this.register.address = ""
        this.register.blood = ""
        this.register.gender = ""
        this.register.genotype = ""
        this.register.dob = ""
        this.register.expiry_date = ""
        this.register.salary_number = ""
        this.register.provider_id = ""
        this.register.point_of_care = ""
        this.register.sector = ""
        this.register.finger_print = ""
        this.register.place_of_work = ""
        this.register.org_id = ""
        this.register.grade_level = ""
        this.register.date_of_entry = ""
        this.register.marital_status = ""
        this.register.category_of_vulnerable_group = ""
      },
      getProviders() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/providerAgency/407465`, {
            params: {
              status: 1,
            },
          })
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProvidersByLGAs() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/providerAgencies/407465/${this.register.localgovt}`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      updateSub() {
        if (
          this.register.category_of_vulnerable_group == "Persons with Disability"
        ) {
          this.sub_vulnerables = [
            "Blind",
            "Deaf",
            "Dwarf",
            "Albino",
            "Mentally Retarded",
            "Paralytic (Physical Disability)",
          ];

        }

        if (this.register.category_of_vulnerable_group == "Chronically ill") {
          this.sub_vulnerables = ["Sickle Cell Disease", "PLHIV", "TB/Leprosy"];
        }

        if (
          this.register.category_of_vulnerable_group == "Pregnant women" ||
          this.register.category_of_vulnerable_group == "Children under 5" ||
          this.register.category_of_vulnerable_group == "Elderly above 60" ||
          this.register.category_of_vulnerable_group == "Retirees" ||
          this.register.category_of_vulnerable_group == "Widows" ||
          this.register.category_of_vulnerable_group == "Poor, below $1 a day"
        ) {
          this.sub_vulnerables = [];
        }

        //update pregnant women to female
        if (this.register.category_of_vulnerable_group == "Pregnant Women") {
          this.register.gender = "Female";
          this.genderDisabled = true;

        }
        else {
          this.genderDisabled = false;
        }

        // DOB min/max for "Children under 5", "Elderly above 60" and
        // "Pregnant Women" is now handled reactively by the dobMin/dobMax
        // computed properties above.
        this.register.dob = "";

      },
    },
    created() {
      this.fetchLga();
      this.getMDAs();
    },
  };
</script>